// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomPageLinkModel, getCustomPageLinks } from "@awc/App/Services/CustomPageLinksService";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

type HandlerType = ApiHandler<{}, ServiceResult<CustomPageLinkModel[]>>;

export const DispatchBeginLoadPageLinks: HandlerType = props => {
    props.dispatch({
        type: "CustomPageLinks/BeginLoadCustomPageLinks",
    } as any);
};

export const GetCustomPageLinks: HandlerType = async props => {
    props.apiResult = await getCustomPageLinks();
};

export const ValidateResult: HandlerType = props => {
    if (!props.apiResult.successful || props.apiResult.result === null) {
        props.apiResult = {
            successful: false,
            errorMessage: `No custom pageLinks were returned from the api. This usually indicates that there was a problem generating the home page or the custom API endpoint is not available. 
Regenerate the site using ?generateIfNeeded=true and then check the logs for errors during generation.`,
        };
    }
};

export const DispatchCompleteLoadPageLinks: HandlerType = props => {
    if (props.apiResult.successful) {
        props.dispatch({
            pageLinks: props.apiResult.result,
            type: "Links/CompleteLoadPageLinks",
        });
        props.dispatch({
            type: "CustomPageLinks/CompleteLoadCustomPageLinks",
        } as any);
    }
};

export const chain = [DispatchBeginLoadPageLinks, GetCustomPageLinks, ValidateResult, DispatchCompleteLoadPageLinks];

const loadCustomPageLinks = createHandlerChainRunner(chain, "LoadCustomPageLinks");

export default loadCustomPageLinks;
